<!--
抽此组件的原因:
新增加css流程,页面和之前request-detail一样但是配套接口不一样,
所以将原写好的request-detail组件抽出来复用
-->
<template>
  <div>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <customize-form-info :infoData="_formData"></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="CREDIT REQUEST">
      <customize-form
        ref="requestForm"
        :isShowForm="true"
        :schema="formModel_R"
        :model="model"
      ></customize-form>
    </el-card>
    <el-card shadow="never" class="card" header="REQUESTOR COMMENTS">
      <quill-editor :token="token" ref="quillEditor"></quill-editor>
      <customize-form
        ref="submitterForm"
        :isShowForm="true"
        :schema="formModel_S"
      >
        <template v-slot:uploadSlot>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :show-file-list="true"
            :on-change="handleChange"
            :limit="5"
            :on-exceed="handleBeyond"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            style="margin-top: 20px"
            :before-remove="beforeRemove"
            :on-remove="handleRemove"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
    </el-card>

    <div class="btnBox">
      <customize-button
        type="primary"
        @click="handleSubmit"
        :loading="isLoading"
      >
        Submit
      </customize-button>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import mixins from '../../mixins/mixins'
import QuillEditor from 'components/quill-editor/QuillEditor.vue'
export default {
  name: 'request-detail',
  mixins: [mixins],
  data() {
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      fileList: [],
      token: '',
    }
  },
  computed: {
    _formData() {
      return this.formData.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        return item
      })
    },
  },
  methods: {
    handleBeyond() {
      this.$message.warning('No more than 5 attachments!')
    },
    handleChange(file) {
      // 单个文件上传
      if (!file.response) {
        const size = file.size / 1024
        if (size < 50000) {
          this.fileList.push(file)
        } else {
          this.$message.error('File must not exceed 50M')
          this.fileList = [...this.fileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
        }
      }
    },
    beforeRemove(file) {
      return this.$confirm(`Confirm delete ${file.name}?`)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        // 单个文件上传
        this.fileList.pop()
      }
    },
    async handleSubmit() {
      try {
        const {
          requestAmount,
          creditCategory,
          requestType,
          customerType,
          eaasType,
        } = this.$refs.requestForm.getFormData()
        const valid = await this.$refs.requestForm.validateFields()
        if (valid) {
          const params = {
            fileList: this.fileList,
            amount: requestAmount,
            remark: this.$refs.quillEditor.getContent().trim(),
            type: creditCategory,
            requestType: requestType,
            customerType,
            eaasType,
          }
          this.$emit('clickSubmit', params)
        }
      } catch (err) {
        console.error(err)
      }
    },
  },
  props: {
    isLoading: {
      type: Boolean,
    },
    formData: {
      type: Array,
      default: () => [],
    },
    formModel_R: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formModel_S: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    QuillEditor,
  },
  mounted() {
    this.token = this.$storage.getItem('token')
  },
}
</script>

<style scoped lang="less">
.btnBox {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card {
  width: 100%;
  margin-bottom: 24px;
}
</style>
